import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M3 6.458C3 5.653 3.674 5 4.506 5h14.988C20.326 5 21 5.653 21 6.458v9.084q-.001.275-.097.516A1.51 1.51 0 0 1 22 17.51v.98c0 .834-.679 1.51-1.516 1.51H3.516A1.513 1.513 0 0 1 2 18.49v-.98c0-.69.464-1.27 1.097-1.452A1.4 1.4 0 0 1 3 15.542zm7.005-.31c.035.482.235.852.477.852h3.036c.242 0 .442-.37.477-.852h5.5c.176 0 .319.139.319.31v9.084c0 .171-.143.31-.32.31H4.506a.314.314 0 0 1-.32-.31V6.458c0-.171.143-.31.32-.31zM3.515 17.19a.32.32 0 0 0-.32.32v.98c0 .177.143.32.32.32h16.97a.32.32 0 0 0 .32-.32v-.98a.32.32 0 0 0-.32-.32z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }